<style scoped src="css/pcData.css"></style>
<template>
  <div class="box">
    <img class="imgCenter" src="~assets/pcTitle2.png" alt="" />
    <div class="content">
      <div class="block1">
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">业务协同</div></div>
          <div class="zjBox">
            <div
              class="zjItemBox"
              v-for="(item, index) in doctorList"
              :key="index"
            >
              <img :src="EnvUrl + item.doctorWorkPhoto" alt="" />
              <div>
                <div class="zjName">{{ item.doctorName }}</div>
                <div class="doctorProfile">{{ item.doctorProfile }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">专家库人员</div></div>
          <div class="personnelBox">
            <div
              class="personnelItem"
              v-for="(item, index) in doctorMap"
              :key="index"
            >
              <div class="personnelName">{{ item.name }}</div>
              <div class="personnelValue">{{ item.value }}</div>
            </div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">线下课程</div></div>
          <div class="courseBox">
            <div
              class="courseItem"
              v-for="(item, index) in offlineCourseList"
              :key="index"
            >
              {{ item.date }}
              <div class="courseIndex">{{ index + 1 }}</div>
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="block2">
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">联防联控</div></div>
          <div class="canvasBox"></div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">家境情况分布</div></div>
          <div class="jjqkBox">
            <div class="jjLine"></div>
            <div class="jjBox">
              <div
                class="jjItem"
                v-for="(item, index) in userTestLevelList1"
                :key="index"
              >
                {{ item.level }}
                <div class="jjNum">{{ item.testCount }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">犯罪认知度</div></div>
          <div class="jjqkBox">
            <div class="jjLine"></div>
            <div class="jjBox">
              <div
                class="jjItem"
                v-for="(item, index) in userTestLevelList2"
                :key="index"
              >
                {{ item.level }}
                <div class="jjNum">{{ item.testCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block3">
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">志愿者活动</div></div>
          <div class="genderBox">
            <div class="zyzword" v-for="(item,index) in activeList" :key="index">{{index+1}}.{{item.name}}</div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">不良心理潜在原因</div></div>
          <div class="qsBox">
            <div id="myChart1"></div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">就业信息</div></div>
          <div class="qsBox">
            <div id="myChart2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";
import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import topbar from "components/topbar";
import moment from "moment/moment";
import footerBox from "components/footer";
import { Swiper, Slide } from "vue-swiper-component";
import wx from "weixin-js-sdk";
import echarts from "echarts";
let components = {
  noMoreData,
  topbar,
  Swiper,
  Slide,
  footerBox,
  newsTopBox,
};
export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      activeList:[],
      employMap:{
        one:0,
        two:0,
        three:0
      },
      reasonMap:{
        one:0,
        two:0,
        three:0,
        four:0
      },
      comboLearnX: null,
      comboLearnY: null,
      comboLevelT1: null,
      comboLevelT2: null,
      comboLevelT3: null,
      comboLevelT4: null,
      comboLevelX: null,
      doctorList: null,
      doctorMap: null,
      userGenderMap: null,
      userTestLevelList1: null,
      userTestLevelList2: null,
      offlineCourseList: null,
    };
  },
  components: components,
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    changeZcTabStatus(i) {
      this.zcTabStatus = i;
    },
    changeCxStatus(i) {
      this.cxStatus = i;
    },
    closeMask() {
      this.mask = false;
      this.ggtpStatus = 0;
      this.zcStatus = 0;
    },
    changeGgtpStatus(i) {
      if (i == 0) {
        this.flag = true;
        this.mask = false;
      } else {
        this.flag = false;
        this.mask = true;
      }
      this.ggtpStatus = i;
    },
    changeStatus(i) {
      this.tabStatus = i;
    },
    changeTtTabStatus(i) {
      this.ttTabStatus = i;
    },
    changeTtTypeStatus(i) {
      this.ttTypeStatus = i;
    },
    changegzStatus(i) {
      this.gzStatus = i;
    },
    changegcCStatus(i) {
      this.gcCStatus = i;
    },
    changezcStatus(i) {
      if (i > 0) {
        this.flag = false;
        this.mask = true;
      } else {
        this.flag = true;
        this.mask = false;
      }
      this.zcStatus = i;
    },
    changeGzdtStatus(i) {
      if (i == -1) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      this.gzdtStatus = i;
    },
    change(i) {
      this.val = [];
      this.id = i;
      if (i == 2) {
        this.workUserList.forEach((v) => {
          this.val.push(v.twoCount);
        });
      } else if (i == 3) {
        this.workUserList.forEach((v) => {
          this.val.push(v.oneCount);
        });
      } else if (i == 4) {
        this.workUserList.forEach((v) => {
          this.val.push(v.zeroCount);
        });
      } else if (i == 1) {
        this.workUserList.forEach((v) => {
          this.val.push(v.threeCount);
        });
      } else {
        this.workUserList.forEach((v) => {
          this.val.push(v.zeroCount + v.oneCount + v.twoCount + v.threeCount);
        });
      }
      this.aa();
    },
    toDetail(i) {
      this.$router.push(`/informationWord?index=${i + 1}`);
    },
    async setEcharts() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("myChart"));
      var myChart1 = echarts.init(document.getElementById("myChart1"));
      var myChart2 = echarts.init(document.getElementById("myChart2"));

      // 指定图表的配置项和数据
      var option = {
        // title: {
        //     text: `出生地总人数(个)：${this.birthPlaceOne + this.birthPlaceZero}`,
        //     // subtext: '300',
        //     left: 20,
        //     top:20
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 20,
          bottom: 20,
          data: ["男", "女"],
          textStyle: {
            //图例文字的样式
            color: "#fff",
          },
        },
        color: ["#249CF9", "#FDB628"],
        series: [
          {
            name: "家庭经济情况",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["60%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
                fontColor: "#ffffff",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.userGenderMap.boy, name: "男" },
              { value: this.userGenderMap.gril, name: "女" },
            ],
          },
        ],
      };
      var option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ["正常", "轻度", "中度", "重度"],
          textStyle: {
            //图例文字的样式
            color: "#fff",
          },
        },
        color: ["#2AC848", "#44C2FF", "#FFB400", "#DE0D0F"],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.comboLevelX,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "正常",
            type: "bar",
            stack: "广告",
            data: this.comboLevelT1,
          },
          {
            name: "轻度",
            type: "bar",
            stack: "广告",
            data: this.comboLevelT2,
          },
          {
            name: "中度",
            type: "bar",
            stack: "广告",
            data: this.comboLevelT3,
          },
          {
            name: "重度",
            type: "bar",
            stack: "广告",
            data: this.comboLevelT4,
          },
        ],
      };

      var option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#11C0FF",
            },
          },
        },
        xAxis: {
          type: "category",
          data: this.comboLearnX,
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: this.comboLearnY,
            type: "line",
            symbol: "none",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#11C0FF",
                },
              },
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      myChart1.setOption(option1);
      myChart2.setOption(option2);
    },
    aa() {
      let that = this;
      let myChart1 = echarts.init(document.getElementById("myChart1"));
      myChart1.setOption({
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          //     type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
          // }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: that.arr,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "总人数",
            type: "bar",
            barWidth: "30%",
            data: that.val,
            //配置样式
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#67D5FD",
                  },
                  {
                    offset: 1,
                    color: "#58A0FF",
                  },
                ]),
                barBorderRadius: [30, 30, 0, 0],
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#9C9C9C",
                    fontSize: 14,
                  },
                },
              },
              //鼠标悬停时：
              // emphasis: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              // }
            },
          },
        ],
      });
    },
    to(n) {
      // this.$router.push(`/informationDetail`)
    },
    clickMe(n) {
      if (n) {
        location.href = n;
      }
    },
    async getWorkService() {
      let data = await getSources(
        "/bear-scale/api/scaleDataScreen/getUserCoopData",
        {}
      );
      if (data.status === 0) {
        this.activeList = JSON.parse(data.activeList)
        this.employMap = JSON.parse(employMap)
        this.reasonMap = JSON.parse(reasonMap)
      } else {
        alert(data.msg);
      }
    },
    changeBespeakAbled(n) {
      this.bespeakAbled = n;
      this.pageIndex = 1;
      this.doctorList = [];
      this.getDoctorList();
    },
    async getScaleData() {
      let obj = {};
      obj.type = 3;
      let data = await getSources(
        "/bear-scale/api/scaleData/getScaleData.json",
        obj
      );
      if (data.status === 0) {
        this.workUserCount =
          data.workUserList[0].zeroCount +
          data.workUserList[0].oneCount +
          data.workUserList[0].twoCount +
          data.workUserList[0].threeCount;
        this.allUserCount = data.workUserList[0].userCount;
        this.drawLine();
      } else {
        alert(data.msg);
      }
    },
    async getScaleData2() {
      let obj = {};
      obj.type = 2;
      let data = await getSources(
        "/bear-scale/api/scaleData/getScaleData.json",
        obj
      );
      if (data.status === 0) {
        this.workUserList = data.workUserList;
        this.workUserList.forEach((v) => {
          this.arr.push(v.shortName);
          this.val.push(v.zeroCount + v.oneCount + v.twoCount + v.threeCount);
        });
        this.aa();
      } else {
        alert(data.msg);
      }
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getDoctorList();
        }
      }
    },
    toNone() {
      const isZzd =
        JSON.stringify(navigator.userAgent).indexOf("TaurusApp") > -1;
      if (!isZzd) {
        location.href =
          "https://dgov-integrate.jinhua.gov.cn:5443/szjh-gov-pc/#/404";
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    localStorage.setItem("sp", true);
    document.title = "社会帮扶e联动";
    // this.drawLine()
    // this.toNone()

    this.getWorkService();
    // this.getScaleData2()
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pcData2.vue?2175df54